import { NavLink } from "react-router-dom";
import styles from "./AdminNavItem.module.css";

type AdminNavItemProps = {
  to: string;
  label: string;
};

function navTestId(path: string): string {
  const slug = path.replace(/^\//, "").replace(/-/g, "_");
  return `admin-nav-${slug}`;
}

export function AdminNavItem({ to, label }: AdminNavItemProps) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive ? styles.linkActive : styles.link
      }
      end
      data-testid={navTestId(to)}
    >
      <span className={styles.dot} aria-hidden />
      <span className={styles.label}>{label}</span>
    </NavLink>
  );
}
